import { cn } from "@babackapp/ui/lib/utils";


export interface LayoutPreviewProps {
	className?: string;
	selectedIndex?: number;
	onSelect?: (index: number) => void;
	displayLabels?: boolean;
}


interface ColumnProps {
	index: number;
	size?: number;
	active?: boolean;
	onClick?: () => void;
	displayLabel?: boolean;
}


function Column({ index, size, active = false, onClick, displayLabel }: ColumnProps) {
	return (
		<div
			className={cn(
				"flex-1 rounded border transition-colors items-center flex p-1",
				onClick && "cursor-pointer",
			)}
			style={{
				maxWidth: size ? `${size}%` : undefined,
				background: active ? "var(--primary)" : "var(--muted)",
			}}
			onClick={onClick}
		>
			{ displayLabel &&
				<div className="text-[10px] text-center select-none" style={{
				color: active ? "#fff" : "var(--muted-foreground)",
			}}>
				Bloc {index + 1}
			</div>
			}
		</div>
	);
}


interface LayoutContainerProps {
	className?: string;
	children: React.ReactNode;
}


function LayoutContainer({ className, children }: LayoutContainerProps) {
	return (
		<div
			className={cn(
				"flex gap-1 w-full h-4",
				className,
			)}
		>
			{children}
		</div>
	);
}


export function Layout66Preview({ className, selectedIndex, onSelect, displayLabels }: LayoutPreviewProps) {
	const handleClick = (index: number) => () => onSelect?.(index);

	return (
		<LayoutContainer className={className}>
			<Column index={0} active={selectedIndex === 0} onClick={handleClick(0)} displayLabel={displayLabels} />
			<Column index={1} active={selectedIndex === 1} onClick={handleClick(1)} displayLabel={displayLabels} />
		</LayoutContainer>
	);
}


export function Layout444Preview({ className, selectedIndex, onSelect, displayLabels }: LayoutPreviewProps) {
	const handleClick = (index: number) => () => onSelect?.(index);

	return (
		<LayoutContainer className={className}>
			<Column index={0} active={selectedIndex === 0} onClick={handleClick(0)} displayLabel={displayLabels} />
			<Column index={1} active={selectedIndex === 1} onClick={handleClick(1)} displayLabel={displayLabels} />
			<Column index={2} active={selectedIndex === 2} onClick={handleClick(2)} displayLabel={displayLabels} />
		</LayoutContainer>
	);
}


export function Layout3333Preview({ className, selectedIndex, onSelect, displayLabels }: LayoutPreviewProps) {
	const handleClick = (index: number) => () => onSelect?.(index);

	return (
		<LayoutContainer className={className}>
			<Column index={0} active={selectedIndex === 0} onClick={handleClick(0)} displayLabel={displayLabels} />
			<Column index={1} active={selectedIndex === 1} onClick={handleClick(1)} displayLabel={displayLabels} />
			<Column index={2} active={selectedIndex === 2} onClick={handleClick(2)} displayLabel={displayLabels} />
			<Column index={3} active={selectedIndex === 3} onClick={handleClick(3)} displayLabel={displayLabels} />
		</LayoutContainer>
	);
}


export function Layout84Preview({ className, selectedIndex, onSelect, displayLabels }: LayoutPreviewProps) {
	const handleClick = (index: number) => () => onSelect?.(index);

	return (
		<LayoutContainer className={className}>
			<Column index={0} size={30} active={selectedIndex === 0} onClick={handleClick(0)} displayLabel={displayLabels} />
			<Column index={1} active={selectedIndex === 1} onClick={handleClick(1)} displayLabel={displayLabels} />
		</LayoutContainer>
	);
}


export function Layout48Preview({ className, selectedIndex, onSelect, displayLabels }: LayoutPreviewProps) {
	const handleClick = (index: number) => () => onSelect?.(index);

	return (
		<LayoutContainer className={className}>
			<Column index={0} active={selectedIndex === 0} onClick={handleClick(0)} displayLabel={displayLabels} />
			<Column index={1} size={30} active={selectedIndex === 1} onClick={handleClick(1)} displayLabel={displayLabels} />
		</LayoutContainer>
	);
}
